import { render, staticRenderFns } from "./EnrolmentQuestionProgramCostEditor.vue?vue&type=template&id=47e6da99&scoped=true"
import script from "./EnrolmentQuestionProgramCostEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionProgramCostEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6da99",
  null
  
)

export default component.exports